import {useBanners} from 'api/queries';
import {FC} from 'react';

import {QueryKeyEnum} from '../../../types';
import {Banners} from '../../pages/main';

interface IProps {
  query: Record<string, string>;
  locale: string;
}

export const PromoBanner: FC<IProps> = ({locale, query}) => {
  const searchPromoSlug = query.promo_type;

  const {data: banners = []} = useBanners(
    [QueryKeyEnum.BANNERS, locale, searchPromoSlug],
    {
      promo_category__slug: searchPromoSlug,
    },
    {},
  );

  if (!banners) return null;

  return <Banners banners={banners} />;
};
